import {JsonProperty} from 'json-typescript-mapper';

export class Branch {
  @JsonProperty('id')
  public id?: number;

  @JsonProperty('name')
  public name?: string;

  @JsonProperty('description')
  public description?: string;

  @JsonProperty('branchNumber')
  public branchNumber?: number;

  @JsonProperty('city')
  public city?: string;

  constructor() {
  this.id =  void 0;
  this.name =  void 0;
  this.description =  void 0;
  this.branchNumber =  void 0;
  this.city =  void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/branch.model.ts